import type { Address } from 'viem'

export const shortenAddress = (string: Address) => {
  if (string.length < 11) {
    return string
  }
  return `${string.substring(0, 6)}...${string.substring(string.length - 4)}`
}
